import { useIdle } from '@ecomm/shared-hooks/useIdle'
import {
  get as sessionStorageGet,
  set as sessionStorageSet
} from '@ecomm/utils'
import { useEffect } from 'react'
import { useModalContext } from '../../lib/ModalContext/useModalContext'

const MODAL_OPENED_FLAG = 'exitIntentModalOpened'

const experimentPages = new Set([
  '/',
  'outdoor-camera-landing',
  'reddit',
  'cameras-landing',
  'travel-landing',
  'shopelectricians',
  'shoprealestate',
  'safety',
  'tiktok',
  'savings',
  'discovery',
  'protect',
  'snapchat',
  'yahoo',
  'pinterest',
  'value',
  'spotify',
  'financing-landing',
  'holiday',
  '/installation-landing',
  'pandora',
  'security',
  'hgtv',
  'save',
  'welcome-back',
  'yahoo-rt',
  'best-security-system',
  'yt',
  'dsp',
  'twitter',
  'facebook',
  'best-security-system-1',
  'welcome-new',
  'quiz',
  'quiz/results',
  'refurb-home-security-systems-2',
  'build-my-system',
  'outdoor-security-camera-series-2',
  'simplicam-security-camera',
  'video-doorbell-pro',
  'outdoor-security-camera',
  'smart-alarm-wireless-indoor-camera',
  'meet-the-system',
  'alarm-sensors/ss3',
  'alarm-sensors/ss2',
  'home-security-shop-packages',
  'business-security-shop'
])

function shouldOpenModal(isIdle: boolean, slug?: string) {
  // True if current page is included in the experiment. See list at https://simplisafe.atlassian.net/browse/ECP-12041
  const isPageInExperiment = !slug || experimentPages.has(slug)

  return isIdle && isPageInExperiment
}

export const useExitIntent = (slug?: string) => {
  const { openModal } = useModalContext()
  // True after user has been idle for 45 seconds
  const isIdle = useIdle(1000 * 45)

  const shouldOpen = shouldOpenModal(isIdle, slug)

  useEffect(() => {
    // This modal should be opened at most once per session
    const hasModalBeenOpenedBefore =
      sessionStorageGet(MODAL_OPENED_FLAG) === 'true'

    shouldOpen && !hasModalBeenOpenedBefore && openModal('exit-intent')

    // If modal was opened, flag it in session storage
    shouldOpen &&
      !hasModalBeenOpenedBefore &&
      sessionStorageSet(MODAL_OPENED_FLAG, 'true')
  }, [openModal, shouldOpen])
}
